// TODO: Review code and functionality; Do NOT use without review
// FIXME: Might call `onSuccess` after calling `onFailure`
import { of } from 'rxjs'
import { delay, mergeMap, retryWhen, takeUntil, tap } from 'rxjs/operators'

export const retry = (opt, fun, onSuccess, onFailure) => {
  const { times, interval } = opt
  let isDone = false

  const run = remainingTime => {
    if (!remainingTime) {
      onFailure(Error('No response received'))
      return
    }

    fun()
      .then(payload => {
        if (isDone) return
        isDone = true
        onSuccess(payload)
      })
      .catch(err => {
        if (isDone) return
        isDone = true
        onFailure(err)
      })

    setTimeout(() => !isDone && run(remainingTime - 1), interval)
  }

  run(times)
}

/**
 *  Tries to resolve a promise until specified tries
 *
 * @param {Function<Promise>} promiseFunction
 * @param {Object} options
 * @param {number} options.times
 * @param {number} options.interval
 *
 * @returns {Promise}
 */
export const retryUntilSucceed = (promiseFunction, options) =>
  new Promise((resolve, reject) => {
    const { times, interval } = options

    const run = remainingTime => {
      if (!remainingTime) reject(Error('No response received'))
      else
        promiseFunction()
          .then(resolve)
          .catch(() => setTimeout(() => run(remainingTime - 1), interval))
    }

    run(times)
  })

export const retryPromiseUntilSucceed = fun => {
  const doTry = (...args) => fun(...args).catch(() => doTry(...args))

  return doTry
}

export const retryUntilSucceedWithCancel$ = (fn, cancel$) =>
  of(null).pipe(
    mergeMap(fn),
    retryWhen(error$ =>
      error$.pipe(tap(console.error), takeUntil(cancel$), delay(1000)),
    ),
  )
